import { render, staticRenderFns } from "./DodatnaAktivnostForma.vue?vue&type=template&id=ccb79a18&scoped=true&"
import script from "./DodatnaAktivnostForma.vue?vue&type=script&lang=js&"
export * from "./DodatnaAktivnostForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb79a18",
  null
  
)

export default component.exports